import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-info-icon',
  imports: [],
  templateUrl: './info-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './info-icon.component.scss',
})
export class InfoIconComponent {}
